module.exports = __webpack_public_path__ + "static/media/empf wireframe.172368c3.gif";